// extracted by css-extract-rspack-plugin
export default {"toast":"HJOkr","progress":"wiehm","animated-progress":"oLvUO"};